import e, { Component as o } from "react";
import { CollapsibleBoxStateless as t } from "./CollapsibleBoxStateless.js";
import "../../../../node_modules/underscore/modules/index-default.js";
import "../../../../node_modules/underscore/modules/_setup.js";
import "../../../../node_modules/underscore/modules/isFunction.js";
import "../../../../node_modules/underscore/modules/_stringTagBug.js";
import "../../../../node_modules/underscore/modules/isArguments.js";
import "../../../../node_modules/underscore/modules/underscore.js";
import "../../../../node_modules/underscore/modules/isMap.js";
import "../../../../node_modules/underscore/modules/isWeakMap.js";
import "../../../../node_modules/underscore/modules/isSet.js";
import "../../../../node_modules/underscore/modules/toPath.js";
import "../../../../node_modules/underscore/modules/iteratee.js";
import "../../../../node_modules/underscore/modules/escape.js";
import "../../../../node_modules/underscore/modules/unescape.js";
import "../../../../node_modules/underscore/modules/templateSettings.js";
import "../../../../node_modules/underscore/modules/partial.js";
import "../../../../node_modules/underscore/modules/bind.js";
import "../../../../node_modules/underscore/modules/bindAll.js";
import "../../../../node_modules/underscore/modules/delay.js";
import "../../../../node_modules/underscore/modules/defer.js";
import "../../../../node_modules/underscore/modules/once.js";
import "../../../../node_modules/underscore/modules/invoke.js";
import "../../../../node_modules/underscore/modules/pick.js";
import "../../../../node_modules/underscore/modules/omit.js";
import "../../../../node_modules/underscore/modules/without.js";
import "../../../../node_modules/underscore/modules/union.js";
import "../../../../node_modules/underscore/modules/difference.js";
import "../../../../node_modules/underscore/modules/zip.js";
import "../../../../node_modules/underscore/modules/underscore-array-methods.js";
import { isToggleSuppressed as r } from "../../../utils/dom/toggle.js";
function n(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function s(e, o) {
  for (var t = 0; t < o.length; t++) {
    var r = o[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function u(e, o, t) {
  return o in e ? Object.defineProperty(e, o, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[o] = t, e;
}
function i(e) {
  return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function l(e, o) {
  return (l = Object.setPrototypeOf || function (e, o) {
    return e.__proto__ = o, e;
  })(e, o);
}
var d = function (o) {
  !function (e, o) {
    if ("function" != typeof o && null !== o) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(o && o.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), o && l(e, o);
  }(a, o);
  var d,
    c,
    p,
    m = (d = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        o,
        t = i(a);
      if (d) {
        var r = i(this).constructor;
        o = Reflect.construct(t, arguments, r);
      } else o = t.apply(this, arguments);
      return (e = o) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : n(this);
    });
  function a() {
    var e;
    return !function (e, o) {
      if (!(e instanceof o)) throw TypeError("Cannot call a class as a function");
    }(this, a), e = m.apply(this, arguments), u(n(e), "_getInitialOpenState", function () {
      var o = e.props.initiallyOpen || e.props.open;
      if (e.props.persistKey) try {
        o = JSON.parse(global.localStorage.getItem(e.props.persistKey)).open;
      } catch (e) {}
      return o;
    }), u(n(e), "_toggle", function (o) {
      if (!r(o)) {
        var t = !e.state.open;
        e.props.persistKey && global.localStorage.setItem(e.props.persistKey, JSON.stringify({
          open: t
        })), e.setState({
          open: t
        });
      }
    }), u(n(e), "state", {
      open: e._getInitialOpenState()
    }), e;
  }
  return c = [{
    key: "render",
    value: function value() {
      var o, r;
      return e.createElement(t, (o = function (e) {
        for (var o = 1; o < arguments.length; o++) {
          var t = null != arguments[o] ? arguments[o] : {},
            r = Object.keys(t);
          "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          }))), r.forEach(function (o) {
            u(e, o, t[o]);
          });
        }
        return e;
      }({}, this.props), r = r = {
        ref: "stateless",
        open: this.state.open,
        onHeaderClick: this._toggle
      }, Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(r)) : function (e, o) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t.push.apply(t, r);
        }
        return t;
      }(Object(r)).forEach(function (e) {
        Object.defineProperty(o, e, Object.getOwnPropertyDescriptor(r, e));
      }), o));
    }
  }], s(a.prototype, c), p && s(a, p), a;
}(o);
u(d, "Stateless", t);
export { d as CollapsibleBoxStateful };